export default "__VITE_ASSET__CdjikhNT__"